import { render, staticRenderFns } from "./NewTerminalToTerminalRoute.vue?vue&type=template&id=4aff58c5"
import script from "./NewTerminalToTerminalRoute.vue?vue&type=script&lang=js"
export * from "./NewTerminalToTerminalRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports